import { useFitnessStore } from '../../../store/fitnessStore';
import { motion } from 'framer-motion';
import { SPORTS } from '../../../utils/sportsData';
import { getGreeting } from '../../../utils/calculations';
import AICoach from '../shared/AICoach';
import ProgressRing from '../shared/ProgressRing';

export default function HomeScreen() {
  const profile = useFitnessStore((s) => s.profile);
  const weeklyStats = useFitnessStore((s) => s.weeklyStats);
  const setScreen = useFitnessStore((s) => s.setScreen);

  const ringData = [
    { name: 'Workouts', value: Math.min((weeklyStats.workouts / 5) * 100, 100), fill: '#E8FF47' },
    { name: 'Time', value: Math.min((weeklyStats.minutes / 240) * 100, 100), fill: '#FF6B35' },
    { name: 'Calories', value: Math.min((weeklyStats.calories / 2500) * 100, 100), fill: '#00D4FF' },
  ];

  return (
    <div style={{ padding: '20px 16px 0' }}>
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginBottom: 2 }}>{getGreeting()}</div>
          <div style={{ fontFamily: 'Bebas Neue', fontSize: 30, lineHeight: 1 }}>{profile.name?.toUpperCase() || 'CHAMPION'}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ background: 'rgba(232,255,71,0.1)', border: '1px solid rgba(232,255,71,0.2)', borderRadius: 12, padding: '8px 12px' }}>
            <div style={{ fontFamily: 'Bebas Neue', fontSize: 22, color: '#E8FF47', lineHeight: 1 }}>{weeklyStats.streak}</div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>DAY STREAK 🔥</div>
          </div>
        </div>
      </motion.div>

      <AICoach screen="home" />

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} style={{ background: '#141416', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 16, padding: 16, marginBottom: 14 }}>
        <div style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.35)', letterSpacing: 1, marginBottom: 12 }}>THIS WEEK</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <ProgressRing data={ringData} size={100} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'Sessions', value: weeklyStats.workouts, target: 5, color: '#E8FF47' },
              { label: 'Training', value: Math.round(weeklyStats.minutes / 60 * 10) / 10, target: 4, color: '#FF6B35', unit: 'h' },
              { label: 'Calories', value: weeklyStats.calories, target: 2500, color: '#00D4FF' },
            ].map(({ label, value, target, color, unit }) => (
              <div key={label}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>{label}</span>
                  <span style={{ fontSize: 11, fontWeight: 600, color }}>
                    {value}{unit || ''}
                    <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: 10 }}>/{target}{unit || ''}</span>
                  </span>
                </div>
                <div style={{ height: 3, background: 'rgba(255,255,255,0.07)', borderRadius: 20 }}>
                  <div style={{ height: 3, borderRadius: 20, background: color, width: `${Math.min((Number(value) / target) * 100, 100)}%`, transition: 'width 0.6s' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }} style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.35)', letterSpacing: 1, marginBottom: 10 }}>QUICK START</div>
        <div className="fit-grid-2">
          {[
            { label: 'Train', emoji: '🏋️', screen: 'workout', color: '#E8FF47' },
            { label: 'Sport', emoji: '🏆', screen: 'sport', color: '#FF6B35' },
            { label: 'Fuel', emoji: '🍎', screen: 'nutrition', color: '#00D4FF' },
            { label: 'Wellness', emoji: '🧘', screen: 'wellness', color: '#B47EFF' },
          ].map((tile) => (
            <button
              key={tile.screen}
              type="button"
              onClick={() => setScreen(tile.screen)}
              style={{ background: '#141416', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 16, cursor: 'pointer', textAlign: 'left' }}
            >
              <div style={{ fontSize: 24, marginBottom: 6 }}>{tile.emoji}</div>
              <div style={{ fontFamily: 'Bebas Neue', fontSize: 18, color: tile.color }}>{tile.label}</div>
            </button>
          ))}
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.35)', letterSpacing: 1 }}>YOUR SPORTS</div>
          <button type="button" onClick={() => setScreen('sport')} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.3)', fontSize: 11, cursor: 'pointer' }}>See all</button>
        </div>
        <div className="fit-scroll-x">
          {SPORTS.slice(0, 5).map((sport, i) => (
            <div
              key={sport.id}
              role="button"
              tabIndex={0}
              onClick={() => setScreen('sport')}
              onKeyDown={(e) => e.key === 'Enter' && setScreen('sport')}
              style={{
                flexShrink: 0, background: '#141416',
                border: `1px solid ${i === 0 ? 'rgba(232,255,71,0.25)' : 'rgba(255,255,255,0.06)'}`,
                borderRadius: 14, padding: '10px 14px', cursor: 'pointer', textAlign: 'center', minWidth: 72,
              }}
            >
              <div style={{ fontSize: 22, marginBottom: 4 }}>{sport.emoji}</div>
              <div style={{ fontSize: 10, fontWeight: 500, color: i === 0 ? '#E8FF47' : 'rgba(255,255,255,0.5)', whiteSpace: 'nowrap' }}>{sport.name.split(' ')[0]}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
